import imageCompression from "browser-image-compression";
import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { newCompany, updateCompany } from 'services/company.routes';
import * as yup from 'yup';
import Fields from './Fields';

export default function NewCompany() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    const schema = yup.object().shape({
        name: yup.string().required(),
        phone: yup.string().required(),
        description: yup.string(),
        address: yup.string().required(),
        logo: yup.mixed(),
    });

    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                phone: state.phone,
                description: state.description || "",
                address: state.address,
            });
        }
    }, [state]);

    const handleFormData = async (info) => {
        let formdata = new FormData();
        const { logo, ...restInformation } = info;
        for (let item in restInformation) {
            if (restInformation[item]) formdata.append(item, restInformation[item]);
        }
        if (logo && logo.length > 0 && logo[0] instanceof File) {
            const compressedImage = await imageCompression(logo[0], { maxSizeMB: 2 });
            formdata.append("logo", compressedImage);
        }
        return formdata;
    };

    const submitCompanyChanges = async () => {
        if (state.id) {
            const formdata = await handleFormData(information);
            setLoading(true);
            updateCompany(state.id, formdata, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    toast.error(data.message);
                } else {
                    toast.success("شرکت ویرایش شد!");
                    navigate(`/company`, { state: data });
                }
            });
        }
    };

    const submitCompany = () => {
        schema
            .validate(information)
            .then(async (res) => {
                if (res) {
                    const formdata = await handleFormData(information);
                    setLoading(true);
                    newCompany(formdata, (isOk, data) => {
                        setLoading(false);
                        if (!isOk) {
                            toast.error(data.message);
                        } else {
                            toast.success("شرکت جدید ایجاد شد!");
                            navigate(`/company`, { state: data });
                        }
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.errors[0]);
            });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <Fields
                method={method}
                information={information}
                handleUpdate={submitCompanyChanges}
                setInformation={setInformation}
                submit={submitCompany}
            />
        </DashboardLayout>
    );
}
